<script lang="typescript">
    import Subtitle2 from "shared/typography/subtitle2.svelte";
    import Headline5 from "shared/typography/headline5.svelte";

    export let title = "Title";
    export let subtitle = "Subtitle and descriptions";
    export let icon;
</script>

<section class="section-header">
    <svelte:component this={icon} width={46} heigth={46} color="var(--color-level-5)" />
    <div class="content">
        <Headline5 text={title} />
        <Subtitle2 text={subtitle} />
    </div>
</section>

<style>
    .section-header {
        display: flex;
        flex-direction: row;
        margin-bottom: 16px;
    }

    .content {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
    }
</style>
